export function comments() {
    const submitButton = document.getElementById('submit');
    const commentBox = document.getElementById('comment');
    if (!submitButton || !commentBox)
        return;
    submitButton.setAttribute('disabled', '');
    submitButton.setAttribute('aria-disabled', 'true');
    commentBox.addEventListener('input', () => {
        if (commentBox.value.length > 0) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-disabled');
        }
        else {
            submitButton.disabled = true;
            submitButton.setAttribute('aria-disabled', 'true');
        }
    });
    if (!commentBox) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-disabled');
    }
}
//# sourceMappingURL=comments.js.map